document.onreadystatechange = () => {
  if (document.readyState === 'interactive') {
    initApp();
  }
}

const UPDATE_INTERVAL = 5 * 1000;

const getBrightColour = () => {
  const hue = 360 * Math.random();
  const sat = 100;
  const light = 55 + 10 * Math.random();

  return `hsl(${hue},${sat}%,${light}%)`;
};

const updateName = () => {
  const name = document.querySelector('#name');
  name.style.color = getBrightColour();
};

const initApp = () => {
  const targets = document.querySelectorAll('a:not(#name)');

  let color = targets[0].style.color;

  updateName();
  setInterval(updateName, UPDATE_INTERVAL);

  for (let i = 0; i < targets.length; i++) {
    let target = targets.item(i);

    let isIcon = target.classList.contains('icon');

    target.addEventListener('mouseover', () => {
      if (isIcon) {
        target.style.backgroundColor = getBrightColour();
      } else {
        target.style.color = getBrightColour();
      }
    });

    target.addEventListener('mouseout', () => {
      if (isIcon) {
        target.style.backgroundColor = color;
      } else {
        target.style.color = color;
      }
    });
  }
};

